// extracted by mini-css-extract-plugin
export default {"container":"CustomerStoryContent-module--container--e8226"};